import { createApi } from "@reduxjs/toolkit/query/react";
import RtkBaseQueryWithReauth from "./RtkBaseQueryWithReauth";
import Config from "../Config";

export interface CreateRefundRequest {
  orderItemId: string;
  orderNumber: string;
  itemNumber: string;
  paymentReference: string;
  amount: number;
  currency: string;
  customerReason: string;
  batch: string;
  productId: string;
  productDenominationsku: string;
}

export interface CreateRefundResponse {
  success: boolean;
  message: string;
}

export interface CreateRefundRequestForAll {
  orderNumber: string;
  itemNumber: string;
  customerReason: string;
  paymentReference: string;
}

export const RefundService = createApi({
  reducerPath: "Refunds",
  baseQuery: RtkBaseQueryWithReauth(Config.BASE_URL),
  tagTypes: ["Refunds"],
  endpoints: (builder) => ({
    // POST Refund
    createRefund: builder.mutation<CreateRefundResponse, CreateRefundRequest>({
      query: (body) => ({
        url: `/refunds`, // your endpoint
        method: "POST",
        body,
      }),
      invalidatesTags: ["Refunds"],
    }),

    createRefundAll: builder.mutation<
      CreateRefundResponse,
      CreateRefundRequestForAll
    >({
      query: (body) => ({
        url: `/refundall`, // your endpoint
        method: "POST",
        body,
      }),
      invalidatesTags: ["Refunds"],
    }),

    // Optionally, you can add list and details endpoints as before
  }),
});

export const { useCreateRefundMutation, useCreateRefundAllMutation } =
  RefundService;
